import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import './file-upload.css';
import Select from "react-select"; 
import { getFileUploadListFromServer, getFileList } from '../../../../services/demo/26as/medicalInsuranceFileUploadService';
import { getFileProcessFromServer, getFileProcessFromServerNew, readmail } from '../../../../services/demo/26as/medicalInsuranceReportService';
import axios from "axios";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../../libraries/loader/loader";
import refreshIcon from "../../../../assets/images/refresh.png";
import { baseUrl } from "../../../../services/common/credentials";
import {port2} from "../../../../services/auth-service/authService";



const localhost_url = baseUrl + port2;

function MedicalInsuranceFileUpload()
{
    const gridColumnDefs = [
        {field: 'source_type', headerName: 'Source Type', sortable: true, filter: true, resizable: true, width: 130},
        {field: 'file_type', headerName: 'File Type', sortable: true, filter: true, resizable: true, width: 150},
        {field: 'month', headerName: 'Input Date', sortable: true, filter: true, resizable: true, width: 100},
        {field: 'extraction_type', headerName: 'Extraction Type', sortable: true, filter: true, resizable: true, width: 125},
        {field: 'file_name', headerName: 'File Name', sortable: true, filter: true, resizable: true, width: 200},
        {field: 'file_size_bytes', headerName: 'File Size (KB)', sortable: true, filter: true, resizable: true, width: 100},
        {field: 'status', headerName: 'Status', sortable: true, filter: true, resizable: true, width: 100},
        {field: 'comments', headerName: 'Comments', sortable: true, filter: true, resizable: true, width: 200},
        {field: 'created_date', headerName:'Upload Date Time', sortable: true, filter: true, resizable: true, width: 200}
    ]

    const [selectedOptions, setSelectedOptions] = useState();
    const [selectedOptions1, setSelectedOptions1] = useState(undefined);
    const [inputMonth, setInputMonth] = useState(undefined);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [finyr, setFinyr] = useState([]);
    const { register, handleSubmit } = useForm();
    const [columnDefs] = useState(gridColumnDefs);
    const [rowData, setRowData] = useState(undefined);
    const [paginationSize] = useState(15);
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [filetypelist, setFileTypeList] = useState([{ value: "Form26as", label: "Form26as"},{ value: "Form26as Password", label: "Form26as Password"},{ value: "ACCPAC", label: "ACCPAC"},{ value: "Sales Register", label: "Sales Register"},{ value: "Customer Master", label: "Customer Master"},{ value: "ERP TAN Update", label: "ERP TAN Update"}],);
    const [compltedDateValue, setcompltedDateValue] = useState([]);

    console.log("date", inputMonth)

    useEffect(() => {
	fetch_file_type_list();
        fetch_financial_year();
        fileUploadsList();
    }, []);


    const onSubmit = async (data) => {
        console.log(userCredentials)
        
        if (selectedOptions === undefined)
        {
            alert("Please Select a File Type before Upload!!!");
        }
        else if (selectedOptions1 === undefined)
        {
            alert("Please Choose the Financial year before Upload!!!");
        }
        else if (data.file[0] === undefined)
        {
            alert("Please Choose a File for Upload!!!");
        }
        else
        {
            const formData = new FormData();

            formData.append("file", data.file[0]);
            formData.append("file_type", selectedOptions["label"]);
            formData.append("tenants_id", userCredentials["tenants_id"]);
            formData.append("groups_id", userCredentials["groups_id"]);
            formData.append("entities_id", userCredentials["selectedentity"]);
            formData.append("user_id", userCredentials["user_id"]);
            formData.append("m_processing_layer_id", userCredentials["m_processing_layer_id"]);
            formData.append("m_processing_sub_layer_id", userCredentials["m_processing_sub_layer_id"]);
            formData.append("processing_layer_id", userCredentials["processing_layer_id"]);
            formData.append("processing_layer_name", "ALCS");
            // formData.append("processing_layer_name", userCredentials["processing_layer_name"]);
            formData.append("source_type", "FILE");
            formData.append("extraction_type", "Upload");
            formData.append("month", selectedOptions1["label"]);
            formData.append("type", "post_file_upload");
            formData.append("m_source_id", 1);
            formData.append("is_processing", 0);


            // console.log("Form Data", data.file[0]);
            // console.log("selected", selectedOptions);
            // console.log("Month", inputMonth);
            try
            {
                setLoaderOpen(true);
				console.log('localhost_url', localhost_url);
                const fileUploadResponse = await fetch(localhost_url+"/api/v2/alcs/file_uploads/", {
                    method: "POST",
                    body: formData,
                }).then((res) => res.json());

                console.log("response", fileUploadResponse);
                if (fileUploadResponse["Status"] !== "Success")
                {
                    alert("Error in Uploading File!!!", fileUploadResponse["Status"]);
                    setLoaderOpen(false);
                }
                else
                {
                      fileUploadsList();
                    alert("File Uploaded Successfully!!!");
                    setSelectedOptions1([]);
                    setSelectedOptions([]);
                    document.getElementById("file-upload-form").reset();
                    document.getElementById("file-upload-month").value = '';
                    setSelectedOptions([]);
                    setSelectedOptions1([]);
                    setLoaderOpen(false);
                }
            }
            catch (err)
            {
                console.log("Error", err);
                setLoaderOpen(false);
            }

            // console.log(JSON.stringify(`${res.message}, status: ${res.status}`));
        }
    };

    function fileUploadsList()
    {
        setLoaderOpen(true);
        let payload = {
            "tenants_id":userCredentials["tenants_id"],
            "entities_id": userCredentials["selectedentity"],
            "m_processing_layer_id": userCredentials["m_processing_layer_id"],
            "m_processing_sub_layer_id": userCredentials["m_processing_sub_layer_id"],
            "processing_layer_id": userCredentials["processing_layer_id"],
            "is_active": "yes",
        }

        var getFileUploadsList = getFileUploadListFromServer();

        axios.get(getFileUploadsList[1], {params : payload}, getFileUploadsList[0])
        .then(
            response => {
                console.log("File Upload Response!!!", response)
                let data = response["data"];
                console.log('data123456', data);
                if (data)
                {
                    let rowData = data;
                    console.log('rowData'+rowData);
                    if(rowData && rowData.length){
                    for(let i = 0; i < rowData.length; i++)
                    {
                        rowData[i]["file_size_bytes"] = Math.round( rowData[i]["file_size_bytes"] * 0.001 ) / 100;
                    }
                    setRowData(rowData);
                    }
					let completedMonths = rowData
                    .filter(item => item.status === "COMPLETED")
                    .map(item => item.input_date);
					console.log('completedMonths', completedMonths);
                    setcompltedDateValue(completedMonths);
                    setLoaderOpen(false);
                }
				setLoaderOpen(false);
            }
        ).catch(
            error => {
                console.log("Error in File Upload List!!!", error);
                setLoaderOpen(false);
            }
        );

    }

    function handleSelect(data) {
        // console.log(data);
        setSelectedOptions(data);
    }

    function handleSelect1(data) {
        // console.log(data);
        setSelectedOptions1(data);
    }


    const customStyles = {
        control: base => ({
          ...base,
          width: 150,
          height: 35,
          minHeight: 35,
          //marginTop: 0,
          //paddingTop: -5,
          fontSize: 14,
		//   left: -30,
         
        })
    };

 
      function readmails() {
        setLoaderOpen(true);
        let payload = {
            // "type": options.value,
            'entities_id': userCredentials["selectedentity"],
            'tenants_id': userCredentials["tenants_id"],
            'groups_id': userCredentials["groups_id"],
            
            
        }
        console.log('payload', payload,userCredentials);

        var getSingleMailSent = readmail();

        axios.post(getSingleMailSent[1], payload, getSingleMailSent[0])
            .then(
                response => {
                    console.log("fetch processed emails list", response)
                    let data = response["data"];
                    console.log('data', data);
                    setLoaderOpen(false);
                }
            ).catch(
                error => {
                    console.log("Error in Fetching processed emails list", error);
                    setLoaderOpen(false);
                }
            );
    }


    function searchForm(){
        setLoaderOpen(true);
        console.log(selectedOptions1);

        if (selectedOptions1=== undefined)
        {
            alert("Please Select year before processing!!!");
            setLoaderOpen(false);
        }
        else{
        console.log(selectedOptions1);
        let payload = {
            "tenants_id": userCredentials["tenants_id"],
            "groups_id": userCredentials["groups_id"],
            "entities_id": userCredentials["entities_id"],
            "m_processing_layer_id": userCredentials["m_processing_layer_id"],
            "m_processing_sub_layer_id": userCredentials["m_processing_sub_layer_id"],
            "processing_layer_id": userCredentials["processing_layer_id"],
            "is_active": "yes",
            "input_date" : inputMonth,
            "period":selectedOptions1.label
        }

        
	console.log('payload', payload);
	var getFileProcess;
        if(userCredentials["selectedentity"] == 1){
            getFileProcess = getFileProcessFromServer(); 
        }
        else if(userCredentials["entities_id"] == 2){
            getFileProcess = getFileProcessFromServer();
        } 

        axios.post(getFileProcess[1],{params : payload}, getFileProcess[0])
        .then(
            response => {
                console.log("File Process Response!!!", response)
                let data = response["data"];
                console.log("response", data)
                if (data["Status"] === "Success")
                {
                    alert("File Processed Successfully!!!");
                    setLoaderOpen(false);
                }else{
                    setLoaderOpen(false);
                }
            }
        ).catch(
            error => {
                console.log("Error in File Process List!!!", error);
                setLoaderOpen(false);
            }
        );
    }}
	
  function fetch_file_type_list()
    {
        setLoaderOpen(true);
        console.log('userCredentials["entities_id"]', userCredentials["entities_id"]);
        let payload = {   
            "entities_id": userCredentials["selectedentity"]  
        }

        var getFileUploadsList = getFileList();
        
        axios.post(getFileUploadsList[1], payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("get file type list", response)
                let data = response["data"];
                let optionList = [
					];
                if (data)
                {
                    for(let key in data){
                        let dict = {
                            value: data[key]["name"],
                            label: data[key]["name"], 
                        }
                        optionList.push(dict);
                    }
                    console.log('optionList1', optionList);
                    setFileTypeList(optionList);
                    setLoaderOpen(false);
                }
            }
        ).catch(
            error => {
                console.log("Error in File Upload List!!!", error);
                setLoaderOpen(false);
            }
        );

    }

const generateFinancialYearOptions = (startYear, numYears) => {
  const optionsyr = [];
  for (let i = 0; i < numYears; i++) {
    const year1 = startYear + i;
    const year2 = year1 + 1;
    const financialYear = `${year1}-${year2}`;
    optionsyr.push({ key: financialYear, value: financialYear, label: financialYear });
  }
  return optionsyr;
};

  function fetch_financial_year() {
    setLoaderOpen(true);
    const startYear = 2020;
    const numYears = 20; // For example, generate 10 years of options

    const financialYearOptions = generateFinancialYearOptions(startYear, numYears);

    setFinyr(financialYearOptions);
    // setclientids(client_ids);    
    setLoaderOpen(false);
  }





	
	const setdatevalue = ({e}) =>{
        let date = e.target.value;
        let dateToCheck = date.toString();
        
        const isDatePresent = compltedDateValue.includes(dateToCheck);
		console.log('compltedDateValue', compltedDateValue);
        if (isDatePresent){
            alert('date is locked!!!');
            setInputMonth(null);
        }else{
            setInputMonth(e.target.value);
        }
        
    }

    return (
        <>
            <div className="file-upload-cardBox">
                <div className="file-upload-card" style={{height: '100px'}}>
                    <div>
                        <label htmlFor="underline_select " className="numbers" style={{fontSize: '15px'}}>File Type</label><br />
                        <div className="cardName">
                            <div className="dropdown-container"  >
                                <Select id="file-upload-select"
                                // style={{width:'150px'}}
                                options={filetypelist}
                                placeholder="Select Type"
                                value={selectedOptions}
                                onChange={handleSelect}
                                isSearchable={true}
                                styles = {customStyles}
                                //   isMulti
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="file-upload-card" style={{height: '100px'}}>
                    <div>
                        <label  id="underline_select" htmlFor="underline_select " className=" numbers" style={{fontSize: '15px'}}>Financial Year</label><br />
                        <div className="cardName">
                            <div className="dropdown-container"  >
                                <Select id="file-upload-select"
                                // style={{width:'150px'}}
                                options={finyr}
                                placeholder="Select Type"
                                value={selectedOptions1}
                                onChange={handleSelect1}
                                isSearchable={true}
                                styles = {customStyles}
                                //   isMulti
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="file-upload-card">
                    <div>
                        <label htmlFor="underline_select " className="numbers " style={{fontSize: '15px'}}>File Upload</label><br />
                        <form onSubmit={handleSubmit(onSubmit)} id="file-upload-form">
                            <input type="file" {...register("file")} />
                            <input type="submit" value="Upload" className="btn" style={{height:"35px",marginTop: "-60px",marginLeft:"330px",backgroundColor:"#000055",color:"#ffffff"}} />
                        </form>
                        
                        
                    </div>
                   
                    {/* <div className="cardHeader">
                        
                        <h4><a href={""} className="btn" style={{marginTop: "43px"}}> Upload</a></h4>  
                    </div> */}
                </div>
                <div className="file-upload-card">
                   	<button style={{height:"35px",marginLeft:"61px",backgroundColor:"#000055",color:"#ffffff",width:"50px", borderRadius:"9%"}} onClick={searchForm}>
                                    Run
                	</button>
                    </div>
            </div>

            <div className="file-upload">
                <div className="ag-theme-balham fileupload-layer">
                    <AgGridReact
                        columnDefs = {columnDefs}
                        rowData = {rowData}
                        paginationPageSize = {paginationSize}
                        pagination = {true}
                        animateRows = {true}
                    ></AgGridReact>
                </div>
            </div>
            <LoaderComponent loaderOpen = {loaderOpen} />
        </>
    )
}


export default MedicalInsuranceFileUpload;


